<template>
  <section class="agenda tuesday">
    <div class="agenda__content container">
      <div class="agenda__date">
        <div class="date__container">
          <div>
            <h1 class="date__title">
              Wednesday, April 9th
            </h1>
          </div>
          <button class="rotate-btn" v-bind:class="{ 'is-rotated': isRotated, 'iphone-btn': isIphone }"
          @click="seccionVisible = !seccionVisible" v-on:click="toggleRotation">
            <svg :class="{ 'iphone': isIphone }" width="14px" height="9px" viewBox="0 0 18 11">
              <path fill="#3AADCC" d="M9.1,7.8l6.6-6.6C15.8,1.1,16,1,16.1,0.9c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.3
              s0.2,0.3,0.3,0.4C18,1.8,18,2,18,2.2s0,0.4-0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.4l-7.5,7.5C9.8,10.8,9.5,11,9.2,11
              c-0.4,0-0.7-0.1-0.9-0.4L0.8,3.1C0.7,3,0.6,2.8,0.5,2.7C0.3,2.5,0.2,2.4,0.2,2.2c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.2-0.3,0.3-0.4
              S0.9,1.1,1,1c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0,0.5,0.1C2.3,1,2.4,1.1,2.5,1.2L9.1,7.8z"/>
            </svg>
          </button>
        </div>
        <hr class="date__line">
      </div>
      <transition name="fade">
        <div v-show="seccionVisible">
          <div class="cards__container">
            <div class="cards__single grayblue">
              <p class="cards__title">
                Doors Open
              </p>
              <div class="cards__description">
                <p>11:00 AM</p>
              </div>
            </div>
            <div class="cards__single grayblue">
              <p class="cards__title">
                VIP Lunch
              </p>
              <div class="cards__description">
                <p>11:00 PM - 1:45 PM</p>
              </div>
            </div>
            <div v-for="(speaker, index) in firstSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div class="cards__single cocktail">
              <p class="cards__title">
                Cocktail Hour
              </p>
              <div class="cards__description">
                <p>6:00 PM - 7:00 PM</p>
              </div>
            </div>
          </div>
          <div class="cards__container">
            <div v-for="(speaker, index) in secondSet" :key="index" class="cards__single cerulean" :class="speaker.class">
              <div v-if="speaker.imgClass" :class="'speaker-img ' + speaker.imgClass"></div>
              <div v-if="speaker.logoClass" :class="'logo-img ' + speaker.logoClass"></div>
              <div v-if="speaker.imgClass" class="circle"></div>
              <div class="cards__speaker">
                <p class="cards__name">{{ speaker.name }}</p>
                <p class="cards__spktitle" v-html="speaker.position"></p>
                <p v-if="speaker.title" class="cards__spktitle" v-html="speaker.title"></p>
              </div>
              <div class="cards__description">
                <p class="time">{{ speaker.time }}</p>
                <p v-if="speaker.location" class="location">{{ speaker.location }}</p>
              </div>
            </div>
            <div class="cards__single dinner">
              <p class="cards__title">
                DNA Supper Club
              </p>
              <div class="cards__description">
                <p>7:45 PM - 9:30 PM</p>
              </div>
            </div>
            <div class="cards__single party">
              <p class="cards__title">
                Legends Never Die Party
              </p>
              <div class="cards__description">
                <p>9:30 PM - 1:00 AM</p>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<style lang="scss">
  @import '@/styles/components/agenda.scss';
</style>

<script>
export default {
  name: 'Day One',
  data() {
    return {
      seccionVisible: true,
      isRotated: false,
      isIphone: false,
      firstSet: [
      { 
          logoClass: 'zkalyx',
          name: 'Zkalyx',
          title: 'Company Presentation',
          time: '1:45 PM - 2:00 PM',
          class: 'logo'
        },
        {
          name: 'Web3’s Influence on Global Power Shifts: The Decentralization of Wealth and Influence',
          title: 'Panel Moderator: Mauricio Magaldi, Midnight<br>Jakub Zurawinski, Swiss Fortress<br>Toby Gilbert, Coinweb',
          time: '2:00 PM - 2:30 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'swiss',
          name: 'Swiss Fortress',
          title: 'Company Presentation',
          time: '2:30 PM - 2:45 PM',
          class: 'logo'
        },
        {
          logoClass: 'wow',
          name: 'WOW!?',
          title: 'Company Presentation',
          time: '2:45 PM - 3:00 PM',
          class: 'logo'
        },
        {
          name: 'The Rise of AI-Driven Finance: How Blockchain and AI Are Reshaping Capital Markets',
          title: 'Panel Moderator: Chris Miglino, DNA<br>Sergii Grybniak, Phd<br>Reni Achkar, CryptoIndex',
          time: '3:00 PM - 3:30 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'dna',
          name: 'DNA Deal Desk',
          title: 'Platform Presentation',
          time: '3:30 PM - 3:45 PM',
          class: 'logo'
        },
        {
          logoClass: 'kredete',
          name: 'Kredete',
          title: 'Company Presentation',
          time: '3:45 PM - 4:00 PM',
          class: 'logo'
        },
        {
          logoClass: 'zeebu',
          name: 'Zeebu',
          title: 'Company Presentation',
          time: '4:00 PM - 4:15 PM',
          class: 'logo'
        },
        {
          name: 'Beyond the Hype: The Evolution of Tokenized Assets & Real-World Utility',
          title: 'Nick Philpott, Zodia Markets<br>Jakub Bojan, SOIL<br>Eran Barak, Midnight',
          time: '4:15 PM - 4:45 PM',
          class: 'noheight panel'
        },
        {
          logoClass: 'dna',
          name: 'DNA',
          title: 'Company Presentation',
          time: '4:45 PM - 5:00 PM',
          class: 'logo'
        },
        {
          logoClass: 'midnight',
          name: 'Midnight',
          title: 'Company Presentation',
          time: '5:00 PM - 5:15 PM',
          class: 'logo'
        },
        {
          logoClass: 'bos',
          name: 'BitcoinOS',
          title: 'Company Presentation',
          time: '5:15 PM - 5:30 PM',
          class: 'logo'
        },
        {
          name: 'The Convergence of Compute, Web3, and AI',
          title: 'Panel Moderator: Chris Miglino, DNA<br>Troy Plota, Plotograph<br>Tony Evans, CETI AI<br>Logan Golema, Eliza Systems<br>Ling Quing Meng, Lucia Protocols',
          time: '5:30 PM - 6:00 PM',
          class: 'noheight panel'
        },
      ],
      secondSet: [
        {
          imgClass: 'c-b',
          name: 'Fireside Chat: 1-Minute to Midnight',
          title: 'Brock Pierce, DNA<br>Charles Hoskinson, Input Output',
          time: '7:00 PM - 7:45 PM',
        }
      ]
    }
  },
  methods: {
    toggleRotation() {
      this.isRotated = !this.isRotated;
    },
  },
  mounted() {
    this.isIphone = /iPhone/.test(navigator.userAgent);
  }
};
</script>
